// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type {
	PermissionsSupportClientMatrixViewBody,
	RolePermissionsWithContextApiResponse,
} from "../../SuperAdmin/RolePermissions/RolePermissionsTypes";

interface RolePermissionsNotaryInstance {
	getMyPermissions(): Promise<RolePermissionsWithContextApiResponse>;
	postPermissionsSupportClientView(body: PermissionsSupportClientMatrixViewBody): Promise<{ ok: boolean }>;
}

// Module-level singleton instance
let instance: RolePermissionsNotaryInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createRolePermissionsNotary(): RolePermissionsNotaryInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;

	return {
		getMyPermissions: async (): Promise<RolePermissionsWithContextApiResponse> => {
			const url = new URL(baseNotary.namespaceUrl.concat("/my-permissions"));
			try {
				return await baseNotary.getRequest<RolePermissionsWithContextApiResponse>(url);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
		postPermissionsSupportClientView: async (body: PermissionsSupportClientMatrixViewBody): Promise<{ ok: boolean }> => {
			const url = new URL(baseNotary.namespaceUrl.concat("/permissions-support/client-matrix-view"));
			try {
				return await baseNotary.postRequest<{ ok: boolean }>(url, body);
			} catch (err) {
				baseNotary.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getRolePermissionsNotaryInstance(): RolePermissionsNotaryInstance {
	if (!instance) {
		instance = createRolePermissionsNotary();
	}
	return instance;
}
